import { RollCallStyle } from "./RollCallStyle";

import BreadCrumb from "../BreadCrumb/BreadCrumb";
import RollCallAdmin from "../RollCallAdmin/RollCallAdmin";
import { Tab, Tabs } from "react-bootstrap";
import LeaveReqAdmin from "../LeaveReqAdmin/LeaveReqAdmin";

const RollCall = () => {
  return (
    <>
      <BreadCrumb num1="واحد مدیریت" num2="حضور و غیاب" margin="mt-3" />

      <RollCallStyle>
        <Tabs defaultActiveKey="حضور و غیاب" className="mb-3">
          <Tab eventKey="حضور و غیاب" title="حضور و غیاب">
            <RollCallAdmin />
          </Tab>
          <Tab eventKey="درخواست مرخصی" title="درخواست مرخصی">
            <LeaveReqAdmin />
          </Tab>
        </Tabs>
      </RollCallStyle>
    </>
  );
};

export default RollCall;
